<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="databaseconnection_title"
        class="form-control-label">{{$t('views.database.form.title')}}</label>
      <input
        id="databaseconnection_title"
        v-model="item.title"
        :class="['form-control', isInvalid('title') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('title', $event.target.value)">
      <div
        v-if="isInvalid('title')"
        class="invalid-feedback">{{ violations.title }}</div>
    </div>
    <div class="form-group">
      <label
        for="databaseconnection_description"
        class="form-control-label">{{$t('views.database.form.description')}}</label>
      <input
        id="databaseconnection_description"
        v-model="item.description"
        :class="['form-control', isInvalid('description') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('description', $event.target.value)">
      <div
        v-if="isInvalid('description')"
        class="invalid-feedback">{{ violations.description }}</div>
    </div>
    <div class="form-group">
      <label
        for="application_server"
        class="form-control-label">{{$t('views.database.form.server')}}</label>
      <el-select
        id="application_server"
        :class="['select-default', isInvalid('server') ? 'select-danger' : '']"
        placeholder=""
        filterable
        v-model="item.server">
        <el-option v-for="option in servers"
                   class="select-default"
                   :value="option['@id']"
                   :label="option['title']"
                   :key="option['@id']">
        </el-option>
      </el-select>
    </div>
    <div class="form-group">
      <label
        for="databaseconnection_username"
        class="form-control-label">{{$t('views.database.form.username')}}</label>
      <input
        id="databaseconnection_username"
        v-model="item.username"
        :class="['form-control', isInvalid('username') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('username', $event.target.value)">
      <div
        v-if="isInvalid('username')"
        class="invalid-feedback">{{ violations.username }}</div>
    </div>
    <div class="form-group">
      <label
        for="databaseconnection_password"
        class="form-control-label">{{$t('views.database.form.password')}}</label>
      <input
        id="databaseconnection_password"
        v-model="item.password"
        :class="['form-control', isInvalid('password') ? 'is-invalid' : '']"
        type="password"
        required="true"
        placeholder=""
        @input="handleUpdateField('password', $event.target.value)">
      <div
        v-if="isInvalid('password')"
        class="invalid-feedback">{{ violations.password }}</div>
    </div>
    <div class="form-group">
      <label
        for="databaseconnection_port"
        class="form-control-label">{{$t('views.database.form.port')}}</label>
      <input
        id="databaseconnection_port"
        v-model="item.port"
        :class="['form-control', isInvalid('port') ? 'is-invalid' : '']"
        type="number"
        required="true"
        placeholder=""
        @input="handleUpdateField('port', $event.target.value)">
      <div
        v-if="isInvalid('port')"
        class="invalid-feedback">{{ violations.port }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-success">{{$t('buttons.submit')}}</button>
  </form>
</template>

<script>
export default {
  data () {
    return {
      servers: []
    }
  },
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.getServers()
  },

  methods: {
    getServers () {
      this.$http.get('api/servers')
        .then(response => {
          this.servers = response.data['hydra:member']
        })
        .catch(error => {
          if (error.response.status === 400) {
            let text = ''
            for (let i in error.response.data) {
              text += error.response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              timer: 2500
            })
          }
          console.log(error)
        })
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
